var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        { betslipDesktopHolder: !_vm.mobileBigAndBelow },
        { empty: !_vm.betsNo }
      ],
      staticStyle: { height: "100%" }
    },
    [
      _c(
        "div",
        {
          staticClass: "betslip-page",
          class: [
            _vm.currentBetSlipStateName,
            { "betslip-empty": !_vm.betsNo },
            {
              bet_placed_sucessfuly:
                _vm.betSlipStatus.State == 2 &&
                _vm.activeBetSlipHistoryTab !== "active" &&
                _vm.activeBetSlipHistoryTab !== "settled"
            }
          ]
        },
        [
          _vm.isLoggedIn &&
          _vm.mobileBigAndBelow &&
          _vm.betSlipStatus.State != 2
            ? _c(
                "div",
                { staticClass: "preheader" },
                [
                  _c("div", { staticClass: "betslip_balance" }, [
                    _c("span", { staticClass: "pd-icon pd-icon-dp-wallet" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm._f("currency")(_vm.balanceSum)))
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.mobileBigAndBelow && _vm.isLoggedIn
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "close",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.closeBetslipDialog()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.mobileBigAndBelow ||
          (_vm.mobileBigAndBelow && _vm.betSlipStatus.State != 2) ||
          (_vm.betSlipStatus.State == 2 &&
            (_vm.activeBetSlipHistoryTab === "active" ||
              _vm.activeBetSlipHistoryTab === "settled"))
            ? _c(
                "div",
                {
                  staticClass: "betslip-page-header",
                  class: { user_logged_in: _vm.isLoggedIn }
                },
                [
                  _vm.mobileBigAndBelow
                    ? _c(
                        "span",
                        {
                          staticClass: "tab",
                          class: {
                            active:
                              _vm.activeBetSlipHistoryTab !== "active" &&
                              _vm.activeBetSlipHistoryTab !== "settled",
                            disabled: true
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "a-link-",
                              on: {
                                click: function($event) {
                                  return _vm.setTab("BetSlip")
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("BetSlipPage.tab.BetSlip")) +
                                    " "
                                )
                              ]),
                              _vm._v(" "),
                              _c("badge", [_vm._v(_vm._s(_vm.betsNo))])
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showHistoryTabs === true
                    ? [
                        _vm.isLoggedIn && _vm.mobileBigAndBelow
                          ? _c(
                              "span",
                              {
                                staticClass: "tab",
                                class: {
                                  active:
                                    _vm.activeBetSlipHistoryTab === "active"
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "a-link-",
                                    on: {
                                      click: function($event) {
                                        return _vm.setTab("HistoryActive")
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "BetSlipPage.tab.History.active"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isLoggedIn && _vm.mobileBigAndBelow
                          ? _c(
                              "span",
                              {
                                staticClass: "tab",
                                class: {
                                  active:
                                    _vm.activeBetSlipHistoryTab === "settled"
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "a-link-",
                                    on: {
                                      click: function($event) {
                                        return _vm.setTab("HistorySettled")
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "BetSlipPage.tab.History.settled"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mobileBigAndBelow && !_vm.isLoggedIn
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "close",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.closeBetslipDialog()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "placing-bets-msg" }, [
                    _vm._v("Placing Bets...")
                  ])
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.betSlipStatus.State == 2 &&
          _vm.mobileBigAndBelow &&
          _vm.activeBetSlipHistoryTab !== "active" &&
          _vm.activeBetSlipHistoryTab !== "settled"
            ? _c(
                "div",
                { staticClass: "betslip-page-header" },
                [
                  _c(
                    "span",
                    { key: "your_receipt", staticClass: "your_receipt" },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("BetSlip.status.placed.YourReceipt"))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "close",
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeBetslipDialog()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabletAndAbove
            ? _c("div", [
                _c(
                  "div",
                  [
                    _vm.activeBetSlipHistoryTab !== "active" &&
                    _vm.activeBetSlipHistoryTab !== "settled"
                      ? _c("betslip", { on: { setTabFromBetSlip: _vm.setTab } })
                      : _vm.activeBetSlipHistoryTab === "active"
                      ? _c("statement", { attrs: { selectedState: "Open" } })
                      : _vm.activeBetSlipHistoryTab === "settled"
                      ? _c("statement", { attrs: { selectedState: "NonOpen" } })
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.tabletAndAbove
            ? _c(
                "div",
                { staticClass: "mobile_betslip" },
                [
                  _vm.activeBetSlipHistoryTab !== "active" &&
                  _vm.activeBetSlipHistoryTab !== "settled"
                    ? _c("betslip", { on: { setTabFromBetSlip: _vm.setTab } })
                    : _vm.activeBetSlipHistoryTab === "active"
                    ? _c("statement", { attrs: { selectedState: "Open" } })
                    : _vm.activeBetSlipHistoryTab === "settled"
                    ? _c("statement", { attrs: { selectedState: "NonOpen" } })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: {
                "content-class": "dialog-betslip-msg",
                persistent: "",
                fullscreen: false
              },
              model: {
                value: _vm.dialogBetslipMsg.active,
                callback: function($$v) {
                  _vm.$set(_vm.dialogBetslipMsg, "active", $$v)
                },
                expression: "dialogBetslipMsg.active"
              }
            },
            [
              _c("betslip-msg", {
                attrs: { dialogBetslipMsg: _vm.dialogBetslipMsg }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1914b622", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1914b622","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslip/BetslipPage.vue
// module id = null
// module chunks = 